import React, { useState } from "react";
import Swal from "sweetalert2";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { grantHeadAccessAPI } from "./Axios";

const CourseButtonTools = ({
                             course,
                             handleCloseCourse,
                             handleActivatePublication,
                             handleDuplicateCourse,
                             currentUserRole,
                             showHeadAccessButton = true
                           }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  const minisite      = course?.minisitePublication || course?.minisite_publication || {};
  const minisiteId    = minisite.id;
  const minisiteState = minisite.aasmState || minisite.aasm_state;
  const desactAt      = minisite.desactivateAt || minisite.desactivate_at;
  const courseState   = course?.aasmState || course?.aasm_state;

  const today = new Date(); today.setHours(0,0,0,0);
  const isExpired = desactAt ? (new Date(desactAt).setHours(0,0,0,0), new Date(desactAt) < today) : false;

  const headHasAccess =
    course?.minisitePublication?.head?.hasAccess ??
    course?.minisite_publication?.head?.hasAccess ??
    false;
  const [hasHeadAccess, setHasHeadAccess] = useState(headHasAccess);

  const grantHeadAccess = async () => {
    try {
      await grantHeadAccessAPI(course.id);
      await Swal.fire({
        title: "Acceso a Jefatura",
        text:  "La jefatura ahora puede ver este proceso.",
        icon:  "success",
        confirmButtonText: "Aceptar",
      });
      setHasHeadAccess(true);
    } catch (err) {
      const msg = err?.response?.data?.error || "Operación fallida.";
      Swal.fire("Error", msg, "error");
    }
  };

  // Only hide if user has ONLY job_head role (not if they also have admin or recruiter)
  // If user has admin or recruiter, they should see the tools even if they also have job_head
  const isJobHeadOnly = Array.isArray(currentUserRole)
    ? currentUserRole.length === 1 && currentUserRole.includes("job_head")
    : currentUserRole === "job_head";
  
  if (isJobHeadOnly) {
    return null;
  }

  return (
    <ButtonDropdown
      isOpen={open}
      toggle={toggle}
      className="me-sm-1 mb-2 mb-sm-0"
      aria-label="Administrar publicación"
    >
      <DropdownToggle caret color="secondary" size="sm">
        <i className="fas fa-cogs me-2" aria-hidden="true"></i>
        Administrar
      </DropdownToggle>

      <DropdownMenu>
        {courseState === "opened" && minisiteId && minisiteState !== "active" && (
          isExpired ? (
            <DropdownItem disabled>Publicación expirada</DropdownItem>
          ) : (
            <DropdownItem
              tag="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleActivatePublication?.();
              }}
            >
              Activar publicación
            </DropdownItem>
          )
        )}

        {course?.minisite_publication?.aasm_state === "active" && (
          <DropdownItem onClick={handleDuplicateCourse}>Duplicar publicación</DropdownItem>
        )}

        {(course.aasm_state === "closed" || course.aasmState === "closed") && (
          <DropdownItem onClick={() => handleCloseCourse("reopen")}>
            Reabrir proceso
          </DropdownItem>
        )}
        <a className="dropdown-item" href={`/courses/${course.id}/edit`}>Editar publicación</a>

        {course?.trabajandoPublication?.id || course?.trabajando_publication?.id ? (
          <DropdownItem onClick={() =>
            (window.location.href = `/courses/${course.id}/trabajando_publications/${course?.trabajandoPublication?.id || course?.trabajando_publication?.id}`)
          }>
            Ver publicación Trabajando
          </DropdownItem>
        ) : (
          (course.aasm_state === "opened" || course.aasmState === "opened") && (
            <DropdownItem onClick={() =>
              (window.location.href = `/courses/${course.id}/trabajando_publications/new`)
            }>
              Crear publicación Trabajando
            </DropdownItem>
          )
        )}

        {showHeadAccessButton && (
          hasHeadAccess ? (
            <DropdownItem disabled>Jefatura ya tiene acceso</DropdownItem>
          ) : (
            <DropdownItem onClick={grantHeadAccess}>Dar acceso a Jefatura</DropdownItem>
          )
        )}

        <a className="dropdown-item" href="/reports">Descargar postulantes</a>
        {(course.aasm_state === "opened" || course.aasmState === "opened") && (
          <DropdownItem onClick={() => handleCloseCourse("close")}>Cerrar proceso</DropdownItem>
        )}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default CourseButtonTools;
